import { globalStore } from '@stores/globalStore'
import { localizationStore } from '@stores/localizationStore'

import { capitalize } from '@scripts/formatters/string'

const translator = (key: string, isCapitalize: boolean = false) => {
  const globStore = globalStore()
  const localStore = localizationStore()

  const preparedTranslation = localStore.translations[globStore.getCurrentLanguage]
    && localStore.translations[globStore.getCurrentLanguage][key]

  if (!preparedTranslation) {
    return key
  }

  return isCapitalize
    ? capitalize(preparedTranslation)
    : preparedTranslation
}

export default translator
